/* eslint-disable no-unused-vars */
import { useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { ReactComponent as Eye } from "../../assets/images/icons/Eye.svg";
import { ReactComponent as Lock } from "../../assets/images/icons/Lock.svg";
import { ReactComponent as Login } from "../../assets/images/icons/Login.svg";
import { Button } from "../Button";
import AuthService from "../../services/authService";
import { useTranslation } from "react-i18next";

export const HeaderMobileLoginPanel = ({ isOpen, close }) => {
  const { t } = useTranslation("common");
  const { login } = useAuth();
  const [isRegister, setIsRegister] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    company: "",
    email: "",
    password: "",
    confirmPassword: "",
    customerCode: "",
    languageId: "PT",
  });

  if (!isOpen) return null;

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{6,}$/;
    return regex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!isRegister) {
      try {
        await login(formData.email, formData.password);
        window.location.reload();
        close();
      } catch {
        setError("⚠️ Credenciais inválidas.");
      }
    } else {
      if (!validatePassword(formData.password)) {
        setError(
          "Password deve ter 6 caracteres, uma maiúscula, minúscula e símbolo."
        );
        setLoading(false);
        return;
      }
      if (formData.password !== formData.confirmPassword) {
        setError("Passwords não coincidem.");
        setLoading(false);
        return;
      }

      try {
        await AuthService.requestAccess({
          FullName: formData.fullName,
          CompanyName: formData.company,
          Email: formData.email,
          CustomerCode: formData.customerCode,
          LanguageId: formData.languageId,
          Password: formData.password,
          ConfirmPassword: formData.confirmPassword,
        });

        alert("📨 Pedido enviado com sucesso!");
        close();
      } catch (error) {
        setError("⚠️ Pedido não foi enviado.");
      }
    }

    setLoading(false);
  };

  return (
    <div className={`mobile__account ${isOpen ? "mobile__account--open" : ""}`}>
      <form onSubmit={handleSubmit} className="auth-modal__form">
        {!isRegister ? (
          <>
            {error && <p className="auth-modal__error">{error}</p>}
            <label>{t("account.email")}</label>
            <input
              type="email"
              placeholder={t("account.email")}
              value={formData.email}
              onChange={(e) => handleChange("email", e.target.value)}
              required
            />
            <label>{t("account.password")}</label>
            <div className="auth-modal__password">
              <input
                type={showPassword ? "text" : "password"}
                placeholder={t("account.password")}
                value={formData.password}
                onChange={(e) => handleChange("password", e.target.value)}
                required
              />
              <Eye
                className="auth-modal__eye"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            <Button
              text={loading ? "..." : t("account.login")}
              classe="button--white-variant"
              Icon={Login}
            />
            <p className="auth-modal__switch">
              {t("account.resquestAccess.first")}
              <span onClick={() => setIsRegister(true)}>
                {t("account.resquestAccess.link")}
              </span>
            </p>
          </>
        ) : (
          <>
            <h4>{t("registration.title")}</h4>
            {error && <p className="auth-modal__error">{error}</p>}
            <label>{t("registration.labels.name")}</label>
            <input
              type="text"
              value={formData.fullName}
              onChange={(e) => handleChange("fullName", e.target.value)}
              required
            />
            <label>{t("registration.labels.company")}</label>
            <input
              type="text"
              value={formData.company}
              onChange={(e) => handleChange("company", e.target.value)}
            />
            <label>{t("registration.labels.email")}</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => handleChange("email", e.target.value)}
              required
            />
            <label>{t("registration.labels.language")}</label>
            <select
              value={formData.languageId}
              onChange={(e) => handleChange("languageId", e.target.value)}
            >
              <option value="PT">🇵🇹 Português</option>
              <option value="EN">🇬🇧 English</option>
              <option value="ES">🇪🇸 Español</option>
              <option value="FR">🇫🇷 Français</option>
            </select>
            <label>{t("registration.labels.password")}</label>
            <div className="auth-modal__password">
              <input
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={(e) => handleChange("password", e.target.value)}
                required
              />
              <Eye
                className="auth-modal__eye"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            <label>{t("registration.labels.confirmPassword")}</label>
            <div className="auth-modal__password">
              <input
                type={showPassword ? "text" : "password"}
                value={formData.confirmPassword}
                onChange={(e) =>
                  handleChange("confirmPassword", e.target.value)
                }
                required
              />
              <Eye
                className="auth-modal__eye"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            <label>{t("registration.labels.customerCode")}</label>
            <input
              type="text"
              value={formData.customerCode}
              onChange={(e) => handleChange("customerCode", e.target.value)}
            />
            <Button
              text={
                loading
                  ? t("registration.buttons.sendingMessage")
                  : t("registration.buttons.register")
              }
              classe={"button--white-variant"}
              Icon={Lock}
            />
            <p className="auth-modal__switch">
              {t("registration.loginToAccount.first")}
              <span onClick={() => setIsRegister(false)}>
                {t("registration.loginToAccount.link")}
              </span>
            </p>
          </>
        )}
      </form>
    </div>
  );
};
